import styled from '@emotion/styled';
import { ClassAttributes, createElement, StatelessComponent } from 'react';

import theme from '../../../theme';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import DummyRectangle from '../primitive/DummyRectangle';

type Preset = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'body2' | 'body1' | 'caption';
type Size = Preset | number;

interface Props {
  size?: Size;
  length?: number;
  align?: 'left' | 'right' | 'center';
  className?: string;
}

type StyledConponentProps = {
  size: any;
  height: any;
  align?: 'left' | 'right' | 'center';
  length?: number;
};

const DummyContent: StatelessComponent<ClassAttributes<HTMLElement> & Props> = ({
  size = 16,
  length = 66,
  align = 'left',
  className,
}) => {
  const lines = Math.ceil(length / 100);
  const _size: any = typeof size === 'number' ? `${size}px` : theme.typography[size].fontSize;
  const height: any =
    typeof size === 'number' ? `${size * DEFAULT_LINE_HEIGHT_RATE}px` : theme.typography[size].lineHeight;

  if (_size === undefined || height === undefined) {
    throw new Error(`<DummyContent size={${size}}> is invalid.`);
  }

  const bars = [...new Array(lines)].map((_, i) =>
    i === lines - 1 ? (
      <TextLike size={_size} height={height} length={length === 100 ? 100 : length % 100} key={i} />
    ) : (
      <TextLike size={_size} height={height} length={length >= 100 ? 100 : length} key={i} />
    ),
  );

  return (
    <Root size={_size} height={height} align={align} className={className}>
      {bars}
    </Root>
  );
};

const TEXT_LIKE_HEIGHT_RATE = 0.666;
const DEFAULT_LINE_HEIGHT_RATE = 1.5;

const Root = styled('div')<StyledConponentProps>(({ size, height, align }) => [
  flexibleLayoutContainer({
    direction: 'column',
    alignItems: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center',
  }),
  {
    width: '100%',
    padding: `calc((${height} - ${size} * ${TEXT_LIKE_HEIGHT_RATE}) / 2) 0`,
    fontSize: size,
  },
]);

const TextLike = styled(DummyRectangle)<StyledConponentProps>(({ size, height, length }) => ({
  width: `${length}%`,
  height: `calc(${size} * ${TEXT_LIKE_HEIGHT_RATE})`,
  margin: `calc((${height} - ${size} * ${TEXT_LIKE_HEIGHT_RATE})) 0`,
  fontSize: size,
  ':first-of-type': {
    marginTop: 0,
  },
  ':last-child': {
    marginBottom: 0,
  },
}));

export default DummyContent;
